import { useEffect } from 'react';

/**
 * This hook handles clicks outside.
 *
 * @param enabled - whether this hook is enabled or not.
 * @param handler - handler to call when clicked outside.
 * @param refs - either a ref or an array of refs. Clicking those refs would not trigger the handler.
 *               IMPORTANT! - Use memoization when passing an array.
 * @see Menu Overlay Tooltip
 */
export default function useOnClickOutside(enabled, handler, refs) {
  useEffect(() => {
    if (!enabled) return;
    const listener = event => {
      const refsArr = Array.isArray(refs) ? refs : [refs];
      // Do nothing if clicking tooltipRef’s element or descendent elements
      if (refsArr.some(ref => {
        var _ref$current;
        return ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(event.target);
      })) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);

    // eslint-disable-next-line consistent-return
    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [enabled, handler, refs]);
}
//# sourceMappingURL=useOnClickOutside.js.map